import { useSearchIndex } from './use-search-index.hook';
import { SearchIndexEnum } from '@vivli/features/search/infrastructure/enum';

/**
 * The vocab index does not quote its search terms.
 *
 * That used to be a `quoteSearchTerms: false` flag passed down into the browser's own query-string
 * builder. The transformation moved server-side with DEV-1133, so the per-index behaviour is now
 * keyed off which endpoint the request goes to and nothing needs passing.
 */
export const useVocabSearch = () => {
    return useSearchIndex({
        index: SearchIndexEnum.Vocab
    });
};
